import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Flex, Typography } from "antd";
import Logo from "assets/images/DSman_logo_blue_dark.svg";
import styles from "./EmbeddedBooking.module.css"
import { routes } from "router";

const { Text } = Typography;

const EmbeddedBookingLayout = ({ children, setActiveTab, activeTab, onNext, type }) => {
    const navigate = useNavigate()
    const { uuid, id } = useParams()
    return (
        <div className={styles.container}>
            {children}
            <footer className={styles.footer}>
                <Flex gap={8}>
                    <Text>Powered By</Text>
                    <img src={Logo} alt="Logo" className={styles.footerLogo} />
                </Flex>
                {
                    !type && <Flex gap={8} className={styles.formButtons}>
                        {activeTab === 1 && <Button color="primary" variant="outlined" onClick={() => {
                            navigate(routes?.embeddedExperienceDetail({ uuid: uuid, id: id }))
                        }}>Back to Experience Detail</Button>}
                        {activeTab > 1 && <Button color="primary" variant="outlined" onClick={() => {
                            setActiveTab(activeTab - 1)
                        }}>Previous</Button>}
                        <Button type="primary" onClick={() => {
                            onNext()
                        }}>Next</Button>
                    </Flex>
                }
            </footer>
        </div>
    );
};

export default EmbeddedBookingLayout;

EmbeddedBookingLayout.propTypes = {
    children: PropTypes.node.isRequired,
    setActiveTab: PropTypes.func,
    activeTab: PropTypes.number,
    onNext: PropTypes.func,
    type: PropTypes.string
};
